export default {
    approvals: {
        title: "Schválení",
        error: "Došlo k chybě"
    },
    delegates: {
        title: "Delegáti",
        error: "Došlo k chybě",
        noDelegates: "Žádné položky",
        delegateDelete: "Delegát byl smazán",
        confirm: {
            delete: "Smazat delegáta?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Datum zahájení",
            endDate: "Datum ukončení",
        },
        buttons: {
            add: {
                text: "Přidat delegáta"
            }
        }
    },
    employees: {
        title: "Moji zaměstnanci",
        error: "Došlo k chybě",
        empty: "Nenalezeny žádné zaměstnance",
        users: {
            name: "Jméno",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Vyhledávání",
            }
        },
        cta: {
            orders: "Načíst objednávky",
            download: "Stáhnout objednávky",
            search: "Vyhledávání"
        }
    }
}